import { filterSchema } from "@orsane/schema/filters";
import { completedTasksTypeSchema, taskListTypeSchema } from "@orsane/schema/task-lists";
import { BuiltInAttribute } from "@orsane/schema/tasks";
import { z } from "zod";

export const taskListParamsSchema = z.object({
    type: taskListTypeSchema,
    taskListId: z.number().optional(),
    parentTaskId: z.number().optional(),
});

export const taskQueryParamsSchema = taskListParamsSchema.extend({
    filter: z.array(filterSchema).optional(),
    completedTasks: completedTasksTypeSchema,
    parentTaskId: z.number().optional(),
});

/** The type that is used to get params from the URL. Defines the list / screen of tasks we're looking at without further filtering */
export type TaskListParams = z.infer<typeof taskListParamsSchema>;
/** The type that is used to send stuff over the wire (API calls) */
export type TaskQueryParams = z.infer<typeof taskQueryParamsSchema>;

// export type TaskList = {
//     id: number;
//     name: string;
//     description: string | null;
//     created_by: User;
//     created_at: string;
//     updated_at: string;
//     tasks?: Task[];
//     createdBy?: User;
//     icon: string;
//     color: TaskListColor;
//     users: User[];
//     is_archived: boolean;
//     link_id: string;
//     guests_visible: boolean;
// };
export const newListFormSchema = z.object({
    name: z
        .string()
        .min(1, "List name is required")
        .min(2, "List name must be at least 2 characters")
        .max(100, "List name cannot exceed 100 characters"),
    color: z.string().min(1, "Color is required"),
});
export type NewListFormValues = z.infer<typeof newListFormSchema>;

const defaultPreferences = {
    "taskList.grouping": BuiltInAttribute.taskStatus,
    "taskList.groupOrder": "asc",
    "taskList.sorting": BuiltInAttribute.title,
    "taskList.taskOrder": "asc",
    "taskList.completedTasks": "all",
    "taskList.attributes": [],
    "taskList.manualOrder": [] as number[],
    "taskList.manualSubtaskOrder": {} as Record<number, number[]>,
};

type TaskListPreferenceKey = keyof typeof defaultPreferences;
export type TaskListPreferences = Record<TaskListPreferenceKey, any>;
